import { createReducer, on } from '@ngrx/store';
import { TestReportSummarizationActions } from '../actions/report-summarization.action';
import { initialState } from '../states/testReport.state';

export const testReportSummarizationReducer = createReducer(
  initialState,
  on(TestReportSummarizationActions.loadTestReportSummarization, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TestReportSummarizationActions.loadTestReportSummarizationSuccess, (state, { metadata, testReport }) => ({
    ...state,
    metadata,
    testReport,
    loading: false,
  })),
  on(TestReportSummarizationActions.loadTestReportSummarizationFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  on(TestReportSummarizationActions.resetDashboardConfig, () => initialState)
);
